<div class="main no-padding">

  <header-menu></header-menu>

  <div class="content content-wrapper">
    <div class="column size-10">

      <div class="card-view no-border">
        <div class="card-content flow-column">
          <div class="card-title flow-column">
            <h2>{{ 'COMPANY.MANAGER.CUPOM.TITLE.NAME' | translate }}</h2>
            <p>{{ 'COMPANY.MANAGER.CUPOM.TITLE.DESCRIPTION_TEXT1' | translate }}</p>
          </div>
        </div>
        <div class="card-table column size-10">
          <ngx-datatable
            style="width: 100%"
            class="colab-datatable"
            [rows]="rows"
            [columnMode]="'force'"
            [headerHeight]="50"
            [footerHeight]="50"
            [rowHeight]="'auto'"
            [limit]="10">

            <ngx-datatable-column name="Empresa do Cliente" prop="company_name">
              <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
                <span (click)="sort()">{{ 'COMPANY.MANAGER.CUPOM.TABLE.COLUMNS.COMPANY_NAME' | translate }}</span>
              </ng-template>
              <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{value}}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Cupom gerado em" prop="created_at">
              <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
                <span (click)="sort()">{{ 'COMPANY.MANAGER.CUPOM.TABLE.COLUMNS.CUPOM_GENERATED' | translate }}</span>
              </ng-template>
              <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{generatedDate(value)}}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Código do cupom" prop="code">
              <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
                <span (click)="sort()">{{ 'COMPANY.MANAGER.CUPOM.TABLE.COLUMNS.CUPOM_CODE' | translate }}</span>
              </ng-template>
              <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                {{value}}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Valor da compra" prop="purchase_value">
              <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
                <span (click)="sort()">{{ 'COMPANY.MANAGER.CUPOM.TABLE.COLUMNS.BUY_VALUE' | translate }}</span>
              </ng-template>
              <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                <p *ngIf="value > 0">R${{value}},00</p>
                <p *ngIf="value === 0">Não informado</p>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Valor economizado" prop="purchase_economy">
              <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
                <span (click)="sort()">{{ 'COMPANY.MANAGER.CUPOM.TABLE.COLUMNS.ECONOMY_VALUE' | translate }}</span>
              </ng-template>
              <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                <p *ngIf="value > 0">R${{value}},00</p>
                <p *ngIf="value === 0">Não informado</p>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Lançado" prop="confirmed">
              <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
                <span (click)="sort()">{{ 'COMPANY.MANAGER.CUPOM.TABLE.COLUMNS.RELEASED' | translate }}</span>
              </ng-template>
              <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                <p *ngIf="value"><span class="fa fa-check-circle"></span></p>
                <p *ngIf="!value"></p>
              </ng-template>
            </ngx-datatable-column>

          </ngx-datatable>
          <div *ngIf="isLoadingCoupon" class="logo-gif">
            <img src="assets/shared/img/logo_allya.gif">
          </div>
        </div>
      </div>

    </div>
  </div>

</div>
